import { DetailChip } from "@design-system/DataDisplay/DetailChip";
import { Button } from "@design-system/Inputs/Button";
import { Box } from "@design-system/Layout/Box";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { cn } from "@design-system/Utilities";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "./i18n";
export const DefinitionGuidance = () => {
    const { t } = useTranslation(RESOURCE_NAME);

    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => {
        setIsOpen((o) => !o);
    };

    return (
        <FlexCol>
            <FlexRow w="full" justifyContent="between">
                <Text variant="header1" color="primary">
                    {t(keys.content_subtitle)}
                </Text>
                <Button variant="textLink" onClick={toggleOpen} size="sm">
                    {t(keys.guidance_trigger, {
                        context: isOpen ? "close" : "open",
                    })}
                    <Button.Icon name={isOpen ? "chevronUp" : "chevronDown"} />
                </Button>
            </FlexRow>
            <Box
                pt="4"
                className={cn(
                    "grid transition-[grid-template-rows] duration-200 ease-in-out",
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
                )}
            >
                <Box className="overflow-hidden text-small text-secondary">
                    <FlexRow gap="2" alignItems="center" pb="1">
                        <Text variant="caption-bold" color="primary">
                            {t(keys.guidance_title)}
                        </Text>
                        <DetailChip>
                            <DetailChip.Icon name="logo" />
                        </DetailChip>
                    </FlexRow>
                    <Trans
                        t={t}
                        i18nKey={keys.guidance_description}
                        components={{
                            ul: (
                                <ul className="list-inside text-sm text-secondary list-disc" />
                            ),
                            li: (
                                <li
                                    key="key"
                                    className="pl-4 text-sm text-secondary"
                                />
                            ),
                            br: <br className="content-[''] block my-2" />,
                        }}
                    />
                </Box>
            </Box>
        </FlexCol>
    );
};
